import React, { useEffect, useState } from "react";
import { changeAdminPassword, getAdminProfile } from "../../api/adminApi";
import PasswordInput from "../../components/PasswordInput";
import "../../styles/admin.css";
import changePasswordBg from "../../assets/change-password-bg.jpg";

function AdminChangePassword() {
  const [staff, setStaff] = useState(null);

  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const checkAdmin = async () => {
      try {
        const token = localStorage.getItem("staffToken");

        if (!token) {
          window.location.href = "/admin/login";
          return;
        }

        const data = await getAdminProfile();
        setStaff(data.staff);
      } catch (err) {
        localStorage.removeItem("staffToken");
        localStorage.removeItem("staffUser");
        window.location.href = "/admin/login";
      }
    };

    checkAdmin();
  }, []);

  const handleChange = (e) => {
    setError("");
    setSuccess("");

    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setSuccess("");

    if (
      !formData.currentPassword ||
      !formData.newPassword ||
      !formData.confirmPassword
    ) {
      setError("همه فیلدها الزامی هستند.");
      return;
    }

    if (formData.newPassword.length < 6) {
      setError("رمز عبور جدید باید حداقل ۶ کاراکتر باشد.");
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setError("رمز عبور جدید و تکرار آن یکسان نیستند.");
      return;
    }

    try {
      setLoading(true);

      const data = await changeAdminPassword(formData);

      setSuccess(data.message || "رمز عبور شما با موفقیت تغییر کرد.");

      setFormData({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    } catch (err) {
      setError(err.message || "خطا در تغییر رمز عبور.");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("staffToken");
    localStorage.removeItem("staffUser");
    window.location.href = "/admin/login";
  };

  return (
    <div className="admin-panel-page admin-change-password-page">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-brand">
          <h2>چشم هوشمند آموزش</h2>
          <span>پنل مدیریت</span>
        </div>

        <nav className="admin-menu">
          <a href="/admin/dashboard">داشبورد</a>
          <a href="/admin/posts">مدیریت محتوا</a>
          <a href="/admin/create-post">انتشار محتوا</a>
          <a href="/admin/change-password" className="active">
            تغییر رمز عبور
          </a>
        </nav>

        <button className="admin-logout-btn" onClick={handleLogout}>
          خروج
        </button>
      </aside>

      <main
        className="admin-main"
        style={{
          "--change-password-bg": `url(${changePasswordBg})`,
        }}
      >
        <div className="admin-change-password-content">
          <header className="admin-topbar">
            <div>
              <h1>تغییر رمز عبور</h1>
              <p>برای امنیت بیشتر، رمز عبور پنل خود را به‌روزرسانی کنید.</p>
            </div>

            {staff && (
              <div className="admin-user-box">
                <strong>
                  {staff.firstName} {staff.lastName}
                </strong>
                <span>{staff.role}</span>
              </div>
            )}
          </header>

          <section className="admin-form-card">
            <h2>فرم تغییر رمز عبور</h2>
            <p>ابتدا رمز فعلی خود را وارد کنید، سپس رمز جدید را ثبت کنید.</p>

            {error && <div className="admin-error">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="admin-field">
                <label>رمز عبور فعلی</label>
                <PasswordInput
                  name="currentPassword"
                  value={formData.currentPassword}
                  onChange={handleChange}
                  placeholder="رمز عبور فعلی"
                  required
                  autoComplete="current-password"
                />
              </div>

              <div className="admin-field">
                <label>رمز عبور جدید</label>
                <PasswordInput
                  name="newPassword"
                  value={formData.newPassword}
                  onChange={handleChange}
                  placeholder="حداقل ۶ کاراکتر"
                  required
                  autoComplete="new-password"
                />
              </div>

              <div className="admin-field">
                <label>تکرار رمز عبور جدید</label>
                <PasswordInput
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  placeholder="تکرار رمز عبور جدید"
                  required
                  autoComplete="new-password"
                />
              </div>

              <button
                className="admin-submit-btn"
                type="submit"
                disabled={loading}
              >
                {loading ? "در حال تغییر رمز..." : "تغییر رمز عبور"}
              </button>
            </form>
          </section>
        </div>
      </main>

      {success && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 999999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            background: "rgba(2, 8, 23, 0.75)",
            backdropFilter: "blur(10px)",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "420px",
              padding: "34px 28px",
              borderRadius: "28px",
              textAlign: "center",
              color: "#eef4ff",
              background:
                "radial-gradient(circle at top, rgba(34, 197, 94, 0.22), transparent 35%), rgba(15, 23, 42, 0.96)",
              border: "1px solid rgba(74, 222, 128, 0.35)",
              boxShadow: "0 30px 90px rgba(0, 0, 0, 0.45)",
            }}
          >
            <div
              style={{
                width: "72px",
                height: "72px",
                margin: "0 auto 18px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(135deg, #22c55e, #4ade80)",
                color: "white",
                fontSize: "42px",
                fontWeight: 900,
              }}
            >
              ✓
            </div>

            <h2
              style={{
                marginBottom: "10px",
                fontSize: "24px",
                fontWeight: 900,
              }}
            >
              رمز عبور تغییر کرد
            </h2>

            <p
              style={{
                marginBottom: "24px",
                color: "#bbf7d0",
                lineHeight: 2,
                fontSize: "15px",
                fontWeight: 700,
              }}
            >
              {success}
            </p>

            <button
              type="button"
              onClick={() => setSuccess("")}
              style={{
                width: "100%",
                height: "48px",
                border: "none",
                borderRadius: "16px",
                background: "linear-gradient(135deg, #22c55e, #16a34a)",
                color: "white",
                fontFamily: "inherit",
                fontSize: "15px",
                fontWeight: 900,
                cursor: "pointer",
              }}
            >
              متوجه شدم
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminChangePassword;